require('./ruleHeader.i18n.json');
require('./ruleHeader.tpl.html');
require('./ruleHeaderController.js');

const RuleHeaderComponent = {
    templateUrl: '/common/rule/ruleHeader/ruleHeader.tpl.html',
    controller: 'ruleHeaderController',
    bindings: {
        rule: '<',
        isNew: '<',
        canUserManageRules: '<',
        isFieldRule: '<'
    }
};

angular.module('ums')
    .component('uiRuleHeader', RuleHeaderComponent);
